"use client";

import { IconLoader2 } from "@tabler/icons-react";
import { useState } from "react";

export function SubscribeForm() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name) {
      setMessage("Please enter your name");
      setStatus("error");
      return;
    }

    if (!email) {
      setMessage("Please enter your email address");
      setStatus("error");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch("/api/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, name }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || "Successfully subscribed!");
        setStatus("success");
        setEmail("");
        setName("");
      } else {
        setMessage(data.error || "Failed to subscribe");
        setStatus("error");
      }
    } catch {
      setMessage("Network error. Please try again.");
      setStatus("error");
    }
  };

  return (
    <div className="w-full md:max-w-[380px] justify-self-end font-body" id="subscribe">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 md:justify-end w-full"
      >
        <div className="flex flex-col w-full">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={status === "loading"}
            className="px-4 py-3 mb-3 rounded-none border border-white/80 bg-black text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white w-full disabled:opacity-50"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === "loading"}
            className="px-4 py-3 rounded-none border border-white/80 bg-black text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white w-full disabled:opacity-50"
          />
        </div>
        <div className="flex flex-row w-full items-center">
          {/* Fixed height container to prevent layout shifts */}
          <div className="col-span-1 w-full">
            {(
              <div
                className={`text-sm ${
                  status === "success" ? "text-green-400" : "text-red-400"
                }`}
              >
                {message || " "}
              </div>
            )}
          </div>
          <button
            type="submit"
            disabled={status === "loading"}
            className="px-6 shrink-0 py-3 w-32 text-center bg-white text-black font-bold rounded-none border border-white/80 hover:bg-gray-200 transition disabled:opacity-50 disabled:cursor-not-allowed self-end"
          >
            {status === "loading" ? (
              <IconLoader2 className="animate-spin inline-block" />
            ) : (
              "SIGN UP"
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
